import 'slick-carousel';

export default class ProductGallery {
  constructor() {
    this.productGallery = document.querySelector("[data-slick-carousel]");
    if (this.productGallery !== null) {
      this.init();
    }
  }

  init() {
    $("[data-slick-carousel]").slick({
      slidesToScroll: 2,
      slidesToShow: 2,
      infinite: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 639,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 506,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}
